<template>
  <v-card width="100%" class="ml-7">
    <v-card-title>
      Predračun
    </v-card-title>

    <v-card-text>
      Generisanje predračuna za kompaniju.
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="generateAccountings"
      >
        Generiši predračun
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import JSZip from 'jszip';
import * as apiCompanies from '../api/companies.js';


export default {
  name: 'PreInvoiceGenerate',

  props: {
    companyId: {
      type: Number,
      required: true
    }
  },

  data: function () {
    return {
      loading: false
    }
  },

  methods: {
    async generateAccountings() {
      this.loading = true;

      try {
        const dueDate = new Date().toISOString();

        const response = await apiCompanies.getPreInvoiceAccountings(
          this.companyId,
          dueDate,
          this.$store.getters.token
        );

        if (response.ok === false) {
          throw new Error('Greška prilikom generisanja predračuna.');
        }

        const zipBlob = await response.blob();
        const zip = await JSZip.loadAsync(zipBlob);

        const pdfFiles = Object.values(zip.files)
          .filter(file =>
            file.dir === false &&
            file.name.toLowerCase().endsWith('.pdf')
          );

        for (const pdfFile of pdfFiles) {
          const pdfBlob = await pdfFile.async('blob');

          const pdfUrl = window.URL.createObjectURL(pdfBlob);

          window.open(pdfUrl, '_blank');
        }
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.loading = false;
      }
    }
  }
}
</script>
